import { forwardRef } from 'react';
import { Icon, IconifyIcon } from '@iconify/react';
import { Box, BoxProps, SxProps, Theme } from '@mui/material';

interface Props extends BoxProps {
  sx?: SxProps<Theme>;
  width?: number | string;
  height?: number | string;
  color?: string;
  icon: string | IconifyIcon;
}

export const Iconic = forwardRef(({ icon, width = 20, sx, ...other }: Props, ref) => (
  <Box ref={ref} component={Icon} icon={icon} sx={{ width, height: width, ...sx }} {...other} />
));
